import { useMediaQuery } from "../../foundations/useMediaQuery";

export default function InfiniteMasonrySkeleton() {
  const isMobile = useMediaQuery("md");
  return (
    <div className="flex flex-wrap gap-2">
      {Array(20)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            className="bg-grey-2 rounded-2"
            style={{
              width: `calc(100% / ${isMobile ? 2 : 5} - 8px)`,
              aspectRatio: 9 / 16,
            }}
          />
        ))}
    </div>
  );
}
